/*
© Copyright 2021 Orolabs.ai to present
* All rights reserved.
* Unauthorized copying of this file, via any medium is strictly prohibited.
* Proprietary and confidential.
* Author: 
*/

import type { SVGProps } from "react"

const Link01 = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...props} fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.2426 1.75736C12.5858 -0.585786 16.3848 -0.585787 18.7279 1.75736C21.0711 4.10051 21.0711 7.8995 18.7279 10.2426L17.3137 11.6569C16.9232 12.0474 16.29 12.0474 15.8995 11.6569C15.509 11.2663 15.509 10.6332 15.8995 10.2426L17.3137 8.82843C18.8758 7.26633 18.8758 4.73367 17.3137 3.17157C15.7516 1.60948 13.219 1.60948 11.6569 3.17157L10.2426 4.58579C9.85212 4.97631 9.21895 4.97631 8.82843 4.58579C8.4379 4.19526 8.4379 3.5621 8.82843 3.17157L10.2426 1.75736ZM14.4497 6.03551C14.8403 6.42604 14.8403 7.0592 14.4497 7.44973L7.44975 14.4497C7.05922 14.8403 6.42606 14.8403 6.03553 14.4497C5.64501 14.0592 5.64501 13.426 6.03553 13.0355L13.0355 6.03551C13.4261 5.64499 14.0592 5.64499 14.4497 6.03551ZM4.58579 8.82843C4.97631 9.21895 4.97631 9.85212 4.58579 10.2426L3.17157 11.6569C1.60948 13.219 1.60948 15.7516 3.17157 17.3137C4.73367 18.8758 7.26633 18.8758 8.82843 17.3137L10.2426 15.8995C10.6332 15.509 11.2663 15.509 11.6569 15.8995C12.0474 16.29 12.0474 16.9232 11.6569 17.3137L10.2426 18.7279C7.8995 21.0711 4.10051 21.0711 1.75736 18.7279C-0.585787 16.3848 -0.585786 12.5858 1.75736 10.2426L3.17157 8.82843C3.5621 8.4379 4.19526 8.4379 4.58579 8.82843Z"
      fill={props.fill || 'currentColor'}
    />
  </svg>
)

export default Link01
